// import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import { ComponentRenderHooks, ListItemsHooks } from "@/plugins/types";
import { EditorButton, Properties, SimpleButtonProperties } from "./component";
import settings from "./settings";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
// import { SimpleHeadlineProperties } from "../../v1/headline/Headline";
// import { ComponentTypes } from "../../types";

export const onListItems = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT) {
    return [settings];
  }
};

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    payload.type === ComponentTypes.BUTTON
  ) {
    return [EditorButton];
  }

  if (
    hook.id === ComponentRenderHooks.PROPERTIES &&
    hook.type === ComponentTypes.BUTTON
  ) {
    return Properties(payload);
  }

  if (
    hook.id === ComponentRenderHooks.SIMPLE_PROPERTIES &&
    hook.type === ComponentTypes.BUTTON
  ) {
    return SimpleButtonProperties(payload);
  }
};
